import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { ConfigService } from './commons';
import { UserInfo } from './interfaces';

export interface IMasterConfig {
  idParameterType: number;
  name: string;
  parameters: { idParameter: number; name: string }[];
}
@Injectable({
  providedIn: 'root'
})
export class MastersService {
  analytics = new BehaviorSubject<IMasterConfig>(null);
  images = new BehaviorSubject<IMasterConfig>(null);
  userData = new BehaviorSubject<UserInfo>(null);
  service: {
    userId: any;
    contactoCRM: any;
    userName: any;
    firstName: any;
    lastName: any;
    fullName: any;
    email: any;
    isResponsable: boolean;
    hasAccessToSettlement: boolean;
    roles: any;
  };

  constructor(private http: HttpClient, private config: ConfigService, private auth: AuthService) {}
}
